import { c as t } from "./index-Di82Y7n3.js";
const e = {
  primary: "text-primary-foreground-color",
  primaryText: "text-primary-foreground",
  secondary: "text-secondary-foreground-color",
  secondaryText: "text-secondary-foreground",
  tertiary: "text-tertiary-foreground-color",
  tertiaryText: "text-tertiary-foreground",
  success: "text-success-foreground-color",
  successText: "text-success-foreground",
  warning: "text-warning-foreground-color",
  warningText: "text-warning-foreground",
  destructive: "text-destructive-foreground-color",
  destructiveText: "text-destructive-foreground",
  info: "text-info-foreground-color",
  infoText: "text-info-foreground",
  runkeeper: "text-runkeeper-foreground-color",
  body: "text-gray-900",
  white: "text-white",
  light: "text-light",
  dark: "text-dark",
  muted: "text-muted-foreground",
  inherit: "text-inherit"
}, n = t("antialiased mb-0", {
  variants: {
    variant: {
      visible: "",
      hidden: "sr-only",
      "mobile-hidden": "sr-only sm:not-sr-only"
    },
    color: e,
    align: {
      left: "text-left",
      center: "text-center",
      right: "text-right"
    },
    fontWeight: {
      body: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold",
      inherit: "font-inherit"
    },
    size: {
      inherit: "text-inherit",
      sm: "text-sm leading-normal",
      md: "text-md leading-normal",
      lg: "text-lg leading-snug",
      xl: "text-xl leading-snug",
      "2xl": "text-2xl leading-snug",
      "3xl": "text-3xl leading-snug",
      display: "text-display leading-snug"
    },
    modifier: {
      underline: "underline",
      italic: "italic",
      pretty: "text-pretty"
    },
    truncate: {
      fit: "truncate",
      wrap: "whitespace-break-spaces",
      "1-line": "line-clamp-1",
      "2-lines": "line-clamp-2",
      "3-lines": "line-clamp-3"
    },
    fontFamily: {
      inherit: "font-inherit",
      montserrat: "font-montserrat",
      "permanent-marker": "font-permanent-marker"
    }
  },
  defaultVariants: {
    color: "inherit",
    fontWeight: "body",
    variant: "visible",
    fontFamily: "inherit"
  }
});
export {
  n as t
};
